import {List} from 'immutable'

import firedux from '../firedux'

import {
  CONVERSATION_STACKS_ENDPOINT
} from '../../config/constants'

export default (currentUserUid, viewportType, stack) => {
  const ref = firedux.ref.child(CONVERSATION_STACKS_ENDPOINT).child(viewportType).child(currentUserUid)

  if (List.isList(stack)) stack = stack.toJS()

  return ref.set(stack)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/conversation_stack.js
 **/